import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-overlay"></div>
      <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
        <div className="hero-logo-badge">
          <span className="badge-text">Professional Cleaning Services</span>
        </div>
        <h1 className="hero-title">
          Fresh. Clear. <span className="gradient-text">A+ Crystal Clean.</span>
        </h1>
        <p className="hero-subtitle">
          We're A+ Crystal Clean, a family-owned cleaning company with years of experience in Europe and the U.S. Our mission is simple — to make your home or office shine!
          <br />
          We use professional cleaning products, offer flexible scheduling, and always treat every space with care and attention to detail.
        </p>
        <button onClick={scrollToBooking} className="hero-cta-button">
          Get a Free Quote
        </button>
        <div className="scroll-indicator">
          <ChevronDown size={24} className="bounce" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
